import ReactDOMServer from "react-dom/server";
import {Button, notification} from "antd";
import {CloseOutlined, CopyOutlined} from "@ant-design/icons";
import {v4} from "uuid";

function CustomContent({content, contentStyle, closeButtonId, copyButtonId, contentId}) {
    return (
        <div style={{display: 'flex', alignItems: 'start', ...(contentStyle || {})}} id={contentId}>
            {content}
            <div>
                <Button
                    id={closeButtonId}
                    size={'small'}
                    icon={<CloseOutlined/>}
                    type={'text'}
                />
                <br/>
                <Button
                    id={copyButtonId}
                    size={'small'}
                    icon={<CopyOutlined/>}
                    type={'text'}
                />
            </div>
        </div>
    )
}

export default function createLeafletPopup({content, L, properties, contentStyle, latlng, map}) {
    const closeId = v4()
    const copyId = v4()
    const contentId = v4()
    const html = ReactDOMServer.renderToString(<CustomContent contentId={contentId} content={content}
                                                              contentStyle={contentStyle} copyButtonId={copyId}
                                                              closeButtonId={closeId}/>)

    const popup = L.popup(properties)
        .setLatLng(latlng)
        .setContent(html)
        .openOn(map);

    const draggable = new L.Draggable(popup._container, popup._wrapper);
    draggable.enable();

    popup.options.closeButton = false
    document.getElementById(closeId).addEventListener('click', (e) => {
        e.preventDefault()
        popup?.remove()
    })

    document.getElementById(copyId).addEventListener('click', (e) => {
        e.preventDefault()

        const elTable = document.getElementById(contentId)
        let range, sel;

        if (document.createRange && window.getSelection) {

            range = document.createRange();
            sel = window.getSelection();
            // unselect any element in the page
            sel.removeAllRanges();

            try {
                range.selectNodeContents(elTable);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(elTable);
                sel.addRange(range);
            }

            document.execCommand('copy');
        }

        sel.removeAllRanges();
        notification.success({
            message: 'Message Copied!'
        })
    })
}